import React, { Component, Fragment } from "react";
import classnames from "classnames";
import { Row, Col, Card, CardBody, FormGroup } from "reactstrap";
import Ionicon from "react-ionicons";
import { Redirect, withRouter } from "../../utils/router-compat";
import _ from "lodash";
// components
import TruckBusPointsReports from "../../components/TruckBusPointsReports/TruckBusPointsReports";
import AutoSuggestionDealer from "../../components/AutoSuggestionDealer/AutoSuggestionDealer";
// import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";
import YTDFilter from "../../components/YTDFilter/YTDFilter";
// services
import DashboardService from "../../services/DashboardService";
import StorageService from "../../services/Storage";
import SpeacialEngagementService from "../../services/SpecialEngagementService";
import HODashboardService from "../../services/HODashaboardService";
// utils
import {
  formatNumber,
  downlodFile,
  // findMonthFromFirstQToPreviousQMonths,
  // findCurrentQuarterMonths
} from "../../utils/utils";

// modals
import SpeacialEngagement from "../../modal/SpeacialEngagement/SpeacialEngagement";

// css
import "./DashboardReport.css";
import FleetManagerService from "../../services/FleetManagerService";
import { askForPermissioToReceiveNotifications } from "../../push-notification.js";
import ModalService from "../../services/ModalService";
import UserService from "../../services/UserService";
import AboutService from "../../services/AboutService";
import moment from "moment-timezone";
import { Permissions } from "../../constants/constant.permissions";
import { Roles } from "../../constants/constant.role";

const isValidClubName = (clubName) =>
  clubName &&
  String(clubName).trim() !== "" &&
  String(clubName).toLowerCase() !== "null";

const formatClubDisplayName = (clubName) => {
  if (!isValidClubName(clubName)) {
    return "N/A";
  }
  const normalizedClub = String(clubName).trim();
  return `${normalizedClub.charAt(0).toUpperCase()}${normalizedClub.slice(1)} Club`;
};

const formatClubLabel = (clubName) => {
  if (!isValidClubName(clubName)) {
    return "N/A";
  }
  const normalizedClub = String(clubName).trim();
  return `${normalizedClub.charAt(0).toUpperCase()}${normalizedClub.slice(1)}`;
};

const SALES_ACHIEVEMENT_SUB_DEFAULT = {
  direct_achievement: 0,
  direct_sales: 0,
  percent_direct_sales: 0,
  indirect_achievement: 0,
  indirect_sales: 0,
  percent_indirect_sales: 0,
  total_sales: 0,
  total_achievement: 0,
  percent_total_sales: 0,
};

const SALES_ACHIEVEMENT_DEFAULT = {
  tbr: { ...SALES_ACHIEVEMENT_SUB_DEFAULT },
  tbb: { ...SALES_ACHIEVEMENT_SUB_DEFAULT },
  total: { ...SALES_ACHIEVEMENT_SUB_DEFAULT },
};

class DashboardReport extends Component {
  primaryPointsReports = [];

  offTakeSummary = {
    totalEarnedPoints: 0,
    pointsSummary: [],
  };

  isMobile = false;

  constructor(props) {
    super(props);

    this.state = {
      userDetail: StorageService.getUserDetail(),
      redirectToVerificationStatus: false,
      zoneName: "All India",
      redirectToInvoiceVerification: false,
      fmOfftakeEntriesCount: {},
      totalPrimaryPoints: 0,
      totalPrivionalPoints: 0,
      totalPoints: 0,
      totalPointsOfftake: 0,
      totalPrimaryPointsOfftake: 0,
      totalPrivionalPointsOfftake: 0,
      tableData: [],
      sales_achievement: { ...SALES_ACHIEVEMENT_DEFAULT },
      DirectIndirecttableData: [],
      fleetStatusCountData: [],
      mobilityCountData: [],
      MobilityTBR: null,

      totalCard: {
        points: 0,
        offtake: 0,
      },
      currentQuarter: {
        points: 0,
        offtake: 0,
      },
      previousQuarters: {
        points: 0,
        offtake: 0,
      },
      currentMonth: {
        points: 0,
        offtake: 0,
      },
      offtakeVerificationCount: {
        approved: 0,
        rejected: 0,
        pending: 0,
      },
      memberId: null,
      memberType: null,
      memberName: null,
      sapid: null,
      memberRole: StorageService.getUserDetail().type,
      fmDetail: null,
      coming_from_dashboard: null,
      isSpecialEngagementModalOpen: false,
      isLoader: false,
      total_count_offtake: 0,
      total_count_directIndirect: 0,
      total_count_fleetStatus: 0,
      yearOptions: [],
      year: null,
      displayLabels: null,
      year_name_value: {},
      zone: "all",
      HOD: false,
      zoneHeader: null,
      openDashboard: false,
      labels: {},
      totals: {},
      clubPoint: null,
      clubName: "",
    };
    this.YTDFilter = React.createRef();
  }


  componentDidMount() {
    this.getDisplayLabel();
    this.getCardDataForFM("");
    askForPermissioToReceiveNotifications();
    this.filterAPI();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      const location = this.props.location;
      if (
        location.pathname === "/" &&
        location.search === "" &&
        location.search !== prevProps.location.search
      ) {
        window.scroll(0, 0);
        this.setState({ memberId: null, memberName: null }, () => {
          this.filterAPI();
        });
        return;
      }

      if (location.search !== prevProps.location.search) {
        this.filterAPI();
      }
    }
  }

  // getCurrentFinancialYear() {
  //   let today = moment();
  //   let year = today.format("YYYY");
  //   let fiscalYear = "";
  //   if ((new Date().getMonth() + 1) <= 3) {
  //     fiscalYear = (parseInt(year) - 1) + "-" + year.substring(2);
  //   } else {
  //     fiscalYear = year + "-" + (parseInt(year) + 1).toString().substring(2);
  //   }
  //   return fiscalYear;
  // }

  getAboutDetail = async (yearVal, club_name) => {
    let selectedYearValObj =
      yearVal && this.state.yearOptions && this.state.yearOptions.length > 0
        ? this.state.yearOptions.find(
          (item) => Number(item.value) === Number(yearVal)
        )
        : null;

    let selectedYearVal =
      selectedYearValObj && selectedYearValObj.name
        ? selectedYearValObj.name
        : null;

    try {
      const userDetail = StorageService.getUserDetail();
      this.setState({ isLoading: true });
      const { data } = await AboutService.getAboutDetails();
      if (data && data.data) {
        let aboutData = data.data;
        let year =
          moment()
            .tz("Asia/Kolkata")
            .month() +
            1 <=
            3
            ? moment()
              .tz("Asia/Kolkata")
              .year() - 1
            : moment()
              .tz("Asia/Kolkata")
              .year();
        const currentFinancialYear = `${year}-${`${year + 1}`.slice(2, 4)}`;
        let currentFyear = selectedYearVal || currentFinancialYear;
        let yearlyAboutData =
          aboutData[currentFyear]["allCategoryPoints"]["points"];
        let fleetType = club_name || "";
        // let fleetType = userDetail && userDetail.fleet_type && userDetail.fleet_type || null;
        // let fleetType = 'diamond';  // blue
        if (
          userDetail &&
          fleetType &&
          fleetType !== null &&
          fleetType !== undefined &&
          fleetType !== ""
        ) {
          let modifiedFleetType = `${fleetType.charAt(0).toUpperCase() +
            fleetType.slice(1)} Club`; // Blue Club
          const filteredFleetTypeArr =
            yearlyAboutData && yearlyAboutData.length > 0
              ? yearlyAboutData.filter(
                (subArr) => subArr[0] === modifiedFleetType
              )
              : [];

          if (filteredFleetTypeArr && filteredFleetTypeArr.length > 0) {
            this.setState({ clubPoint: filteredFleetTypeArr[0][1] });
          } else {
            this.setState({ clubPoint: null });
          }
        }
      }
    } catch (error) {
      this.setState({ isLoading: false });
      console.log(error);
    }
  };

  loadInitialData = (memberId = null, val) => {
    if (this.state.year) {
      this.getOfftakeVerificationCount(memberId);
      this.getFleetManagerOfftakeVerificationCount();
      this.getPoints(memberId);
      this.getReport(memberId);
      this.getOfftakeSummary(memberId);
      this.getRedeemData();
      this.getDisplayLabel();
      this.getSalesTargetAchivemet();
      this.getFleetProfileData(memberId);
      this.getClubName(null, this.state.year, memberId);
    }
  };

  getFleetProfileData = async (memberId) => {
    let { userDetail } = this.state;
    try {
      if (memberId) {
        const { data } = await FleetManagerService.getFleetProfileDetail(
          memberId
        );
        if (data && data.data) {
          userDetail = data.data;
        }
        this.setState({ userDetail });
      } else {
        const { data } = await UserService.getUserInfo();
        if (data && data.data) {
          userDetail = data.data;
        }
        this.setState({ userDetail });
      }
    } catch (error) {
      console.log(error);
    }
  };

  checkUserAgent() {
    this.isMobile = false;
    const ua = navigator.userAgent;
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
        ua
      )
    ) {
      this.isMobile = true;
      return "mobile";
    }
    if (/Chrome/i.test(ua)) {
      return "chrome";
    }
    return "other";
  }

  sumBusOfftakeAndPoints(arr) {
    let offtake = 0;
    let totalPoints = 0;
    arr.forEach((item) => {
      offtake += item.bias + item.radial;
      totalPoints +=
        item.biasPoints +
        item.radialPoints +
        item.consistencyBonusPoints +
        item.slabJumpPoints +
        item.schemePoints +
        item.approvalPoints +
        item.openingBalance;
    });
    return { offtake, totalPoints };
  }

  getOfftakeSummary = (memberId) => {
    this.setState((prevState) => {
      return { ...prevState, isLoading: true };
    });
    this.setState({ isLoader: true });
    DashboardService.getOfftakeSummary(memberId, this.state.year)
      .then((data) => {
        this.offTakeSummary = {
          totalEarnedPoints: 0,
          pointsSummary: data.data.data,
        };
        this.setState({ isLoader: false });
        this.offTakeSummary.pointsSummary = _.filter(
          this.offTakeSummary.pointsSummary,
          (element) => {
            return (
              element.label.indexOf("uarter") !== -1 || element.points !== 0
            );
          }
        );
        this.offTakeSummary.totalEarnedPoints = _.sumBy(
          this.offTakeSummary.pointsSummary,
          (element) => {
            return element.points;
          }
        );
        this.setState((prevState) => {
          return { ...prevState, isLoading: false };
        });
      })
      .catch((e) => {
        this.setState({ isLoader: false });
        this.setState((prevState) => {
          return { ...prevState, isLoading: false };
        });
      });
  };

  async getReport(memberId) {
    try {
      this.setState({
        isLoader: true,
      });
      const { data } = await DashboardService.getReportAll(
        memberId,
        this.state.zone,
        this.state.year
      );

      this.primaryPointsReports = [];
      const offtake = {
        totalPointsOfftake: 0,
        totalPrimaryPointsOfftake: 0,
        totalPrivionalPointsOfftake: 0,
      };
      if (data) {
        if (data.data && data.data.labels) {
          this.setState({ labels: data.data.labels });
        }
        if (data.data && data.data.totals) {
          this.setState({ totals: data.data.totals });
        }

        if (data.data && data.data.q1) {
          data.data.q1.quarter = 1;
          offtake.totalPrimaryPointsOfftake = data.data.q1.data.totalOfftake;
          this.primaryPointsReports.push(data.data.q1);
        }
        if (data.data && data.data.q2) {
          data.data.q2.quarter = 2;
          offtake.totalPrivionalPointsOfftake = data.data.q2.data.totalOfftake;
          this.primaryPointsReports.push(data.data.q2);
        }
        if (data.data && data.data.q3) {
          data.data.q3.quarter = 3;
          this.primaryPointsReports.push(data.data.q3);
        }
        if (data.data && data.data.q4) {
          data.data.q4.quarter = 4;
          this.primaryPointsReports.push(data.data.q4);
        }
        this.primaryPointsReports.reverse();
        // this.setState({ isLoader: false });
      }
      // let result = {};
      // this.primaryPointsReports.forEach(element => {
      //   // Sum offtake And Totalpoints
      //   // truck/bus
      //   result = this.sumBusOfftakeAndPoints(element.data.report.truck);
      //   element.truckOfftake = result.offtake;
      //   element.truckTotalPoints = result.totalPoints;
      // });
      if (
        offtake.totalPrimaryPointsOfftake !== undefined &&
        offtake.totalPrivionalPointsOfftake !== undefined
      ) {
        offtake.totalPointsOfftake =
          offtake.totalPrimaryPointsOfftake +
          offtake.totalPrivionalPointsOfftake;
      }
      this.setState((prevState) => {
        return { ...prevState, ...offtake };
      });
      this.setState({ isLoader: false });
    } catch (error) {
      console.log(error);
      this.setState({ isLoader: false });
    }
  }

  getPoints = (memberId) => {
    memberId = memberId ? memberId : "all";
    this.setState({
      isLoader: true,
    });
    DashboardService.getPoints(memberId, this.state.zone, this.state.year)
      .then((data) => {
        const res = data.data.data;
        // res = {
        //   "previousQuarters": {
        //     "points": "757250",
        //     "offtake": "5291"
        //   },
        //   "currentQuarter": {
        //     "points": 322580,
        //     "offtake": 3266
        //   },
        //   "total": {
        //     "points": 1186410,
        //     "offtake": 9459
        //   }
        // };

        const { total, currentQuarter, previousQuarters, currentMonth } = res;
        this.setState({
          totalCard: total,
          currentQuarter,
          previousQuarters,
          currentMonth,
        });
        // const primaryPoints = res.primaryPoints;
        // const provisionalPoints = res.provisionalPoints;
        // // const year = res.year;
        // this.setState((prevState) => {
        //   return { ...prevState, totalPrimaryPoints: primaryPoints, totalPrivionalPoints: provisionalPoints, totalPoints: primaryPoints + provisionalPoints };
        // });
      })
      .catch((e) => {
        this.setState({
          // isLoader: false,
        });
      });
  };

  getFleetManagerOfftakeVerificationCount = async () => {
    let { fmOfftakeEntriesCount } = this.state;

    try {
      const { data } = await FleetManagerService.getOfftakeEntriesCount(
        this.state.year
      );
      if (data) {
        if (this.state.memberRole === Roles.FLEET_MANAGER_ROLE) {
          fmOfftakeEntriesCount =
            _.filter(data.data, (item) => {
              return (item.status || "").toLowerCase() === "pending";
            })[0] || {};
        } else {
          fmOfftakeEntriesCount =
            _.filter(data.data, (item) => {
              return (item.status || "").toLowerCase() === "pending_zfm";
            })[0] || {};
        }
      }
      this.setState({ fmOfftakeEntriesCount });
    } catch (error) {
      console.log(error);
    }
  };

  downloadSalesReport = () => {
    let controls = this.YTDFilter.current.state.controls;
    let filter = {};
    filter = {
      y: controls.year.value ? controls.year.value : this.state.year,
      m: controls.month.value ? controls.month.value : null,
      q: controls.quarter.value ? controls.quarter.value : null,
    };
    this.setState({ isLoader: true });
    HODashboardService.downloadSalesReport(filter)
      .then((res) => {
        this.setState({ isLoader: false });
        if (res.data && res.data.data && res.data.data.file) {
          downlodFile(res.data.data.file);
        }
        this.setState({ isLoader: false });
      })
      .catch((e) => {
        if (e.response && e.response.data && e.response.data.message) {
          ModalService.openAlert("", e.response.data.message, "error");
        }
        this.setState({
          isLoader: false,
        });
        console.log("err", e);
      });
  };

  downloadVerifiedSales = () => {
    let controls = this.YTDFilter.current.state.controls;
    let filter = {};

    filter = {
      y: controls.year.value ? controls.year.value : this.state.year,
      m: controls.month.value ? controls.month.value : null,
      q: controls.quarter.value ? controls.quarter.value : null,
    };

    this.setState({ isLoader: true });
    HODashboardService.downloadVerifiedSales(filter)
      .then((res) => {
        this.setState({ isLoader: false });
        if (res.data && res.data.data && res.data.data.file) {
          downlodFile(res.data.data.file);
        }
        this.setState({ isLoader: false });
      })
      .catch((e) => {
        this.setState({
          isLoader: false,
        });
        if (e.response && e.response.data && e.response.data.message) {
          ModalService.openAlert("", e.response.data.message, "error");
        }
        console.log("err", e);
      });
  };

  getSalesTargetAchivemet = () => {
    // this.setState({ isLoader: true });
    let controls =
      this.YTDFilter.current && this.YTDFilter.current.state.controls;
    // if (StorageService.getUserDetail().type !== Roles.FLEET_MANAGER_ROLE) {
    //   return;
    // }

    let filter = {
      y:
        controls && controls.year.value ? controls.year.value : this.state.year,
      m: controls && controls.month.value ? controls.month.value : null,
      q: controls && controls.quarter.value ? controls.quarter.value : null,
    };

    DashboardService.getSalesTargetAchivemet(filter)
      .then((res) => {
        const apiData = (res.data && res.data.data) || {};
        const sales_achievement = {
          tbr: { ...SALES_ACHIEVEMENT_SUB_DEFAULT, ...(apiData.tbr || {}) },
          tbb: { ...SALES_ACHIEVEMENT_SUB_DEFAULT, ...(apiData.tbb || {}) },
          total: { ...SALES_ACHIEVEMENT_SUB_DEFAULT, ...(apiData.total || {}) },
        };
        this.setState((prevState) => {
          return {
            ...prevState,
            sales_achievement,
          };
        });
      })
      .catch((e) => {
        // this.setState({ isLoader: false });
      });
  };

  getOfftakeVerificationCount = (memberId) => {
    this.setState({ isLoader: true });
    DashboardService.getOfftakeVerificationCount(memberId, this.state.year)
      .then((res) => {
        const result = {
          approved: 0,
          rejected: 0,
          pending: 0,
        };
        // this.setState({ isLoader: false });
        if (res.data.data && res.data.data.length > 0) {
          res.data.data.forEach((element) => {
            if ((element.status || "").toLowerCase() === "pending") {
              result.pending = element.count;
            } else if ((element.status || "").toLowerCase() === "approved") {
              result.approved = element.count;
            } else if ((element.status || "").toLowerCase() === "rejected") {
              result.rejected = element.count;
            }
          });
        }
        this.setState((prevState) => {
          return {
            ...prevState,
            offtakeVerificationCount: result,
          };
        });
      })
      .catch((e) => {
        // this.setState({ isLoader: false });
      });
  };

  redirectToAbout = () => {
    this.props.history.push("/about");
  };

  openDashboard = () => {
    if (this.state.HOD === "true" || this.state.HOD === true) {
      StorageService.removeSelectedFmData();
      window.scroll(0, 0);
      this.props.history.push("/dashboard");
      this.setState({ memberId: null, memberName: null, memberType: null });
    } else {
      StorageService.removeSelectedFmData();
      window.scroll(0, 0);
      this.props.history.push("/");
      this.onChangeZone(
        "",
        this.state.zoneHeader ? this.state.zoneHeader : this.state.zone
      );
      this.setState({ memberId: null, memberName: null, memberType: null });
    }
  };

  openReportPage = (fmDetail) => {
    if (fmDetail && fmDetail.uuid) {
      this.props.history.push(`/report?y=${this.state.year}`);
    } else {
      StorageService.removeSelectedFmData();
      this.props.history.push(`/report?y=${this.state.year}`);
    }
  };

  onPendingInvoiceClick = () => {
    let { redirectToInvoiceVerification } = this.state;
    redirectToInvoiceVerification = true;
    this.setState({ redirectToInvoiceVerification });
  };

  goToOfftakeVerificationStatus = () => {
    let { redirectToVerificationStatus } = this.state;
    redirectToVerificationStatus = true;
    const { memberId, memberName, memberRole, sapid } = this.state;
    // let uuid = this.state.memberId;
    if (memberRole === Roles.FLEET_MANAGER_ROLE) {
      this.props.history.push(
        `/OfftakeEntriesVerificationStatus?id=${memberId}&name=${memberName}&sapid=${sapid}&zone=${this.state.zone}&HOD=${this.state.HOD}&y=${this.state.year}&cfd=${this.state.coming_from_dashboard}`
      );
    } else if (memberRole === Roles.ZONAL_FLEET_MANAGER_ROLE) {
      this.props.history.push(
        `/OfftakeEntriesVerificationStatus?id=${memberId}&name=${memberName}&sapid=${sapid}&zone=${this.state.zone}&HOD=${this.state.HOD}&y=${this.state.year}&cfd=${this.state.coming_from_dashboard}`
      );
    } else if (memberRole === Roles.HEAD_OFFICE_BAADSHAH_ROLE) {
      this.props.history.push(
        `/OfftakeEntriesVerificationStatus?id=${memberId}&name=${memberName}&sapid=${sapid}&zone=${this.state.zone}&HOD=${this.state.HOD}&y=${this.state.year}&cfd=${this.state.coming_from_dashboard}`
      );
    } else {
      this.props.history.push(
        `/OfftakeEntriesVerificationStatus?y=${this.state.year}`
      );
    }
  };

  redirectFromBannerAction = () => {
    if (
      this.state.action &&
      this.state.action === "gift-catalogue" &&
      StorageService.getUserDetail() &&
      StorageService.getUserDetail().permissions &&
      StorageService.getUserDetail().permissions.includes(
        Permissions.REDEMPTION_CATALOGUE
      )
    ) {
      this.props.history.push(`/redemption-catalog`);
    }
  };

  getRedeemData = () => {
    DashboardService.getRedeemData(this.state.year)
      .then((data) => {
        // // data = {
        // //   data: {
        // //     data: {
        // //       "redeemEnable": true,
        // //       "redeemDays": 15,
        // //       "baadshahMessage": "Currently Baadshah program is showing only direct sales data. All tyre purchase data from dealers with their points will be updated soon."
        // //     }

        // //   }
        // }
        const {
          baadshahMessage = null,
          redeemDays,
          redeemEnable,
          action = null,
        } = data.data.data;
        this.setState({
          baadshahMessage,
          redeemDays,
          redeemEnable,
          action: action,
        });
      })
      .catch((e) => {
        console.error("e", e);
      });
  };

  getCurrentSelectedFmData = () => {
    let data = StorageService.getSelectedFmData();
    data = data ? JSON.parse(data) : null;
    return data;
  };

  getSelectedFleetData = (
    memberUuid,
    memberName,
    sapid,
    zone,
    memberType,
    memberClubType
  ) => {
    // let e = {
    //   target: {
    //     value: zone
    //   }
    // };
    this.setState(
      {
        memberId: memberUuid,
        memberName,
        sapid,
        coming_from_dashboard: true,
        memberType,
      },
      () => {
        this.loadInitialData(this.state.memberId, 8);
      }
    );
  };

  getPopupLink = () => {
    SpeacialEngagementService.getPopupLink(this.state.year)
      .then((data) => {
        if (data.data && data.data.data.link) {
          this.setState({ isSpecialEngagementModalOpen: true });
        }
      })
      .catch((e) => { });
  };

  getDisplayLabel = () => {
    DashboardService.getDisplayLabel(this.state.year)
      .then((data) => {
        const labels = data.data && data.data.data ? data.data.data : null;
        if (this.state.yearOptions[0].value === parseInt(this.state.year)) {
          labels.isCurrentYear = true;
        } else {
          labels.isCurrentYear = false;
        }
        this.setState({ displayLabels: labels });
      })
      .catch((e) => { });
  };

  closeSpecialEngagementModal = () => {
    this.setState({ popupData: null, isSpecialEngagementModalOpen: false });
  };

  onChangeZone = (e, zone) => {
    let zon = null;
    if (e && e.target && e.target.value) {
      zon = e.target.value;
      if (e.target.value == "sz1") {
        this.setState({ zoneName: "South 1" });
      } else if (e.target.value == "sz2") {
        this.setState({ zoneName: "South 2" });
      } else if (e.target.value == "ez") {
        this.setState({ zoneName: "East" });
      } else if (e.target.value === "nz") {
        this.setState({ zoneName: "North" });
      } else if (e.target.value === "wz") {
        this.setState({ zoneName: "West" });
      } else {
        zon = "all";
        this.setState({ zoneName: "All India" });
      }
    } else if (zone) {
      zon = zone;
      if (zone == "sz1") {
        this.setState({ zoneName: "South 1" });
      } else if (zone == "sz2") {
        this.setState({ zoneName: "South 2" });
      } else if (zone == "ez") {
        this.setState({ zoneName: "East" });
      } else if (zone === "nz") {
        this.setState({ zoneName: "North" });
      } else if (zone === "wz") {
        this.setState({ zoneName: "West" });
      }
    }

    this.setState(
      {
        zone: zon,
      },
      () => {
        this.loadInitialData("all", 9);
      }
    );
  };

  getCardDataForFM = (filterValue) => {
    let controls =
      this.YTDFilter.current && this.YTDFilter.current.state.controls;
    if (StorageService.getUserDetail().type !== Roles.FLEET_MANAGER_ROLE) {
      return;
    }

    let filter = {
      y:
        controls && controls.year.value ? controls.year.value : this.state.year,
      m: controls && controls.month.value ? controls.month.value : null,
      q: controls && controls.quarter.value ? controls.quarter.value : null,
    };
    this.setState({ isLoader: true });
    HODashboardService.getOffTakeSalesEntry(filter)
      .then((res) => {
        this.setState({
          total_count_offtake: res.data.data.total_tyres,
          tableData: res.data.data.counts,
        });
        // this.setState({ isLoader: false });
      })
      .catch((err) => {
        this.setState({
          // isLoader: false,
        });
        console.log("err", err);
      });

    HODashboardService.getDirectIndirectData(filter)
      .then((res) => {
        this.setState({
          total_count_directIndirect: res.data.data.total,
          DirectIndirecttableData: res.data.data.data,
        });
        // this.setState({ isLoader: false });
      })
      .catch((err) => {
        this.setState({
          tableData: [],
          isLoaderDD: false,
        });
        console.log("err", err);
      });

    HODashboardService.getFleetStatusCount(filter)
      .then((res) => {
        this.setState({
          total_count_fleetStatus: res.data.data.total,
          fleetStatusCountData: res.data.data.data,
        });
        // this.setState({ isLoader: false });
      })
      .catch((err) => {
        this.setState({
          tableData: [],
          isLoaderCC: false,
        });
        console.log("err", err);
      });
  };

  rounoffValues = (value) => {
    if (value) {
      let val = value.toString().split(".");
      if (val[1]) {
        let val2 = val[1].toString().split("");
        if (val2[0] >= 5) {
          value = Math.ceil(value);
        } else {
          value = Math.floor(value);
        }
      }
      return value;
    }
    return value;
  };

  updateZone = () => {
    this.setState();
  };

  getOffTakeSalesEntry = (filterValue) => {
    this.checkUserAgent();
    this.getCardDataForFM();
    this.loadInitialData();
  };

  getClubName = async (yearName, yearValue, uuid) => {
    this.setState({ isLoader: true });
    await DashboardService.getClubName(yearValue, uuid)
      .then((res) => {
        const fleetTypeFromHistory =
          res && res.data && res.data.data && res.data.data.length > 0
            ? res.data.data[0].fleet_type
            : null;
        const userDetail = StorageService.getUserDetail();
        const fleetType =
          fleetTypeFromHistory ||
          (userDetail && userDetail.fleet_type) ||
          (this.state.userDetail && this.state.userDetail.fleet_type) ||
          null;
        const normalizedClub = isValidClubName(fleetType)
          ? String(fleetType).trim()
          : null;
        if (normalizedClub) {
          this.setState(
            {
              clubName: normalizedClub,
            },
            () => {
              this.getAboutDetail(yearValue || "", this.state.clubName);
            }
          );
        } else {
          this.setState({
            clubName: null,
            clubPoint: null,
          });
        }
        // this.setState({ isLoader: false });
      })
      .catch((err) => {
        this.setState({ isLoader: false });
        console.log("err", err);
      });
  };

  filterAPI = async () => {
    const { year } = this.state;

    let filter = {
      y: year ? year : null,
    };
    this.setState({ isLoader: true });
    await HODashboardService.filterAPI(filter)
      .then((res) => {
        if (res.data.data) {
          // let pushObj = { name: "2019-20", key: "2019-20", value: 2020 };
          // let yearArr = res.data.data.year || []; // create a new array if year is not defined
          // yearArr.push(pushObj);
          this.setState(
            {
              yearOptions: res.data.data.year ? res.data.data.year : [],
              // yearOptions: res.data.data.year ? yearArr : []
            },
            () => {
              if (
                !this.state.year &&
                this.state.yearOptions &&
                this.state.yearOptions[0]
              ) {
                this.setState(
                  {
                    year: this.state.yearOptions[0].value,
                    year_name_value: this.state.yearOptions[0],
                  },
                  () => {
                    const userDetail = StorageService.getUserDetail();
                    const role = userDetail.type;
                    this.setState({ memberRole: role });
                    this.getPopupLink();
                    const searchParam = this.props.location.search;
                    let memberUuid = null;
                    let dealerName = null;
                    if (searchParam) {
                      const keys = searchParam.split("&");
                      const idString = keys[0];
                      const nameString = keys[1];
                      const id = idString.split("=");
                      memberUuid = id[1];
                      const name = nameString ? nameString.split("=") : null;
                      dealerName = name ? decodeURI(name[1]) : null;
                      const sap = keys[2] ? keys[2].split("=") : null;
                      let sapid = sap ? decodeURI(sap[1]) : null;
                      var HODashboard = keys[3] ? keys[3].split("=") : null;

                      const DashboardId = keys[4] ? keys[4].split("=") : null;
                      let DBid = DashboardId ? DashboardId[1] : null;

                      var selYear = keys[5] ? keys[5].split("=") : null;
                      // let year = selYear ? selYear[1] : null;

                      const cfd = keys[6] ? keys[6].split("=") : null;
                      let c_f_d = cfd ? cfd[1] : null;

                      const member_typeKey = keys[7] ? keys[7].split("=") : null;
                      const member_type = member_typeKey ? member_typeKey[1] : null;

                      let HOD = null;
                      let zoneHeader = null;

                      if (HODashboard && HODashboard[0] === "zone") {
                        zoneHeader = HODashboard ? HODashboard[1] : null;
                      }

                      if (DBid && DBid !== "null") {
                        HOD = DBid ? DBid : null;
                      }

                      if (c_f_d === "true" || c_f_d === true) {
                        this.setState({
                          coming_from_dashboard: c_f_d,
                        });
                      } else {
                        this.setState({
                          coming_from_dashboard: false,
                        });
                      }

                      this.setState({
                        memberId: memberUuid,
                        memberName: dealerName,
                        sapid,
                        HOD,
                        zoneHeader,
                        memberType: member_type
                      });
                    }
                    if (
                      (HODashboard && HODashboard[0] === "y") ||
                      (selYear && selYear[0] === "y")
                    ) {
                      this.setState(
                        {
                          year:
                            HODashboard && HODashboard[0] === "y"
                              ? HODashboard[1]
                              : selYear && selYear[1],
                        },
                        () => {
                          if (
                            userDetail.type === Roles.FLEET_MANAGER_ROLE ||
                            userDetail.type ===
                            Roles.ZONAL_FLEET_MANAGER_ROLE ||
                            userDetail.type === Roles.HEAD_OFFICE_BAADSHAH_ROLE
                          ) {
                            if (memberUuid) {
                              const fmDetail = this.getCurrentSelectedFmData();
                              this.setState({ fmDetail });
                              this.loadInitialData(memberUuid);
                              // load member uuid data
                            } else {
                              StorageService.removeSelectedFmData();
                              if (
                                userDetail.type ===
                                Roles.ZONAL_FLEET_MANAGER_ROLE ||
                                userDetail.type ===
                                Roles.HEAD_OFFICE_BAADSHAH_ROLE
                              ) {
                                this.loadInitialData(null);
                              } else {
                                this.loadInitialData("all");
                              }
                              // load all member data
                            }
                          } else {
                            this.loadInitialData();
                            //  load current user data
                          }
                        }
                      );
                    } else {
                      if (
                        userDetail.type === Roles.FLEET_MANAGER_ROLE ||
                        userDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE ||
                        userDetail.type === Roles.HEAD_OFFICE_BAADSHAH_ROLE
                      ) {
                        if (memberUuid) {
                          const fmDetail = this.getCurrentSelectedFmData();
                          this.setState({ fmDetail });
                          this.loadInitialData(memberUuid);
                          // load member uuid data
                          this.getClubName(
                            this.state.yearOptions[0].name,
                            this.state.yearOptions[0].value,
                            memberUuid
                          );
                        } else {
                          this.getClubName(
                            this.state.yearOptions[0].name,
                            this.state.yearOptions[0].value
                          );
                          StorageService.removeSelectedFmData();
                          if (
                            userDetail.type ===
                            Roles.ZONAL_FLEET_MANAGER_ROLE ||
                            userDetail.type === Roles.HEAD_OFFICE_BAADSHAH_ROLE
                          ) {
                            this.loadInitialData(null);
                          } else {
                            this.loadInitialData("all");
                          }
                          // load all member data
                        }
                      } else {
                        this.loadInitialData();
                        //  load current user data
                      }
                    }
                  }
                );
              }
              // else {
              //   this.checkUserAgent();
              //   this.getCardDataForFM();
              //   this.loadInitialData();
              // }
            }
          );
          this.props.updateZone();
        }
      })
      .catch((err) => {
        // this.setState({ isLoader: false });
      });
  };

  downloadFleetStatusReport = (e, fleet, countType) => {
    e.preventDefault();
    let filter = {};
    if (countType === "header_total") {
      filter = {
        y: this.state.year,
      };
    } else {
      filter = {
        y: this.state.year,
        type: fleet,
      };
    }
    this.setState({ isLoader: true });
    HODashboardService.downloadFleetStatusReport(filter)
      .then((res) => {
        // this.setState({ isLoader: false });
        if (res.data && res.data.data && res.data.data.file) {
          downlodFile(res.data.data.file);
        }
        this.setState({ isLoader: false });
      })
      .catch((err) => {
        this.setState({
          isLoader: false,
        });
        console.log("err", err);
      });
  };

  onChangeYear = (e, memberId) => {
    this.setState(
      {
        year: e && e.target && e.target.value,
      },
      () => {
        // this.filterAPI();
        let { yearOptions, year_name_value, year, displayLabels } = this.state;
        if (year) {
          year_name_value = yearOptions.filter((x) => x.value == year);
        }
        if (year_name_value) {
          if (yearOptions[0].value === year) {
            displayLabels.isCurrentYear = true;
          } else {
            displayLabels.isCurrentYear = false;
          }
          year_name_value =
            year_name_value && year_name_value[0]
              ? year_name_value[0]
              : year_name_value;

          this.getClubName(year_name_value.name, year);
          this.setState({ year_name_value, displayLabels });
        }
        this.checkUserAgent(memberId);
        this.getCardDataForFM(memberId);
        this.loadInitialData(memberId);
      }
    );
  };

  render() {
    const {
      memberId,
      memberName,
      fmOfftakeEntriesCount,
      redirectToInvoiceVerification,
      totalCard,
      currentQuarter,
      // previousQuarters,
      // currentMonth,
      offtakeVerificationCount,
      isSpecialEngagementModalOpen,
      memberRole,
      redirectToVerificationStatus,
      // redeemEnable,
      baadshahMessage,
      fmDetail,
      displayLabels,
      sales_achievement,
      labels,
      totals,
      // userDetail,
      clubPoint,
      clubName,
    } = this.state;

    // const previousQMonths = findMonthFromFirstQToPreviousQMonths();
    // const currentQMonths = findCurrentQuarterMonths();
    return (
      <Fragment>
        {/* {this.state.isLoader && <CustomSpinner />} */}
        {redirectToInvoiceVerification && (
          <Redirect to="/invoiceVerification" />
        )}
        {redirectToVerificationStatus && (
          <Redirect to="/offtakeEntriesVerificationStatus" />
        )}
        {isSpecialEngagementModalOpen && (
          <SpeacialEngagement
            show={isSpecialEngagementModalOpen}
            // popupDetail={popupDetail}
            closeModal={this.closeSpecialEngagementModal}
          ></SpeacialEngagement>
        )}
        {memberRole === Roles.FLEET_MANAGER_ROLE && memberId && (
          <Row>
            <Col md="10" xs="8">
              {this.state.coming_from_dashboard ? (
                <span>
                  <span
                    className="prev-page-link cursor-pointer"
                    onClick={this.openDashboard}
                  >
                    Dashboard
                  </span>
                  <span>
                    <Ionicon
                      icon="ios-arrow-forward"
                      fontSize="34px"
                      color="#fdbb1f"
                    />
                  </span>
                </span>
              ) : (
                <span>
                  <span
                    className="prev-page-link cursor-pointer "
                    onClick={this.openReportPage}
                  >
                    Points report for truck / bus
                  </span>
                  <span>
                    <Ionicon
                      icon="ios-arrow-forward"
                      fontSize="34px"
                      color="#fdbb1f"
                    />
                  </span>
                </span>
              )}

              <span className="current-page">
                Details for <span className="title-case">{memberName}</span>
                <span className="title-case">
                  {this.state.sapid && " (" + this.state.sapid + ")"}
                </span>
              </span>
            </Col>
            {this.state.yearOptions.length > 1 &&
              (StorageService.getUserDetail().type !==
                Roles.FLEET_MANAGER_ROLE ||
                StorageService.getUserDetail().type ===
                Roles.FLEET_MANAGER_ROLE) &&
              memberId && (
                <Col
                  md="2"
                  xs="4"
                  style={{ paddingRight: "0px", marginTop: "-15px" }}
                >
                  <Row>
                    <div className="showingText" style={{ paddingTop: "18px" }}>
                      Financial Year &nbsp;
                    </div>
                    <FormGroup style={{ paddingTop: "10px" }}>
                      <select
                        name="month"
                        className="form-control cursor-pointer"
                        value={this.state.year}
                        style={{
                          fontSize: "13px",
                          width: "110px",
                          color: "#6e777f",
                          marginLeft: "auto",
                        }}
                        onChange={(e) => {
                          this.onChangeYear(e, memberId);
                        }}
                      >
                        {this.state.yearOptions.map((item) => (
                          <option value={item.value} selected>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </FormGroup>
                  </Row>
                </Col>
              )}
          </Row>
        )}

        {(this.state.HOD === "true" || this.state.HOD === true) && (
          <Row>
            <Col md={this.state.yearOptions.length > 1 && "10"} xs="12">
              <span>
                <span
                  className="prev-page-link cursor-pointer"
                  onClick={this.openDashboard}
                >
                  Dashboard
                </span>
                <span>
                  <Ionicon
                    icon="ios-arrow-forward"
                    fontSize="34px"
                    color="#fdbb1f"
                  />
                </span>
              </span>

              <span className="current-page">
                Details for <span className="title-case">{memberName}</span>
                <span className="title-case">
                  {this.state.sapid && " (" + this.state.sapid + ")"}
                </span>
              </span>
            </Col>
            {this.state.yearOptions.length > 1 && (
              <Col md="2" xs="12" style={{ paddingRight: "0px" }}>
                <FormGroup>
                  <select
                    name="month"
                    className="form-control cursor-pointer"
                    value={this.state.year}
                    style={{
                      fontSize: "13px",
                      width: "110px",
                      color: "#6e777f",
                      marginLeft: "auto",
                    }}
                    onChange={(e) => {
                      this.onChangeYear(e, memberId);
                    }}
                  >
                    {this.state.yearOptions.map((item) => (
                      <option value={item.value} selected>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
              </Col>
            )}
          </Row>
        )}

        {(memberRole === Roles.ZONAL_FLEET_MANAGER_ROLE ||
          memberRole === Roles.HEAD_OFFICE_BAADSHAH_ROLE) &&
          memberId &&
          (this.state.HOD == "false" ||
            this.state.HOD == false ||
            !this.state.HOD) && (
            <Row>
              <Col md={this.state.yearOptions.length > 1 && "10"} xs="12">
                {this.state.coming_from_dashboard ? (
                  <span>
                    <span>
                      <span
                        className="prev-page-link cursor-pointer"
                        onClick={this.openDashboard}
                      >
                        Point Dashboard
                      </span>
                      <span>
                        <Ionicon
                          icon="ios-arrow-forward"
                          fontSize="34px"
                          color="#fdbb1f"
                        />
                      </span>
                    </span>
                  </span>
                ) : (
                  <span>
                    <span
                      className="prev-page-link cursor-pointer "
                      onClick={this.openReportPage}
                    >
                      Points report for truck / bus
                    </span>
                    <span>
                      <Ionicon
                        icon="ios-arrow-forward"
                        fontSize="34px"
                        color="#fdbb1f"
                      />
                    </span>
                  </span>
                )}

                {/* {fmDetail && fmDetail.uuid && fmDetail.name && (
                  <>
                    <span
                      className="prev-page-link cursor-pointer "
                    // onClick={this.openReportPage.bind(this, fmDetail)}
                    >
                      Points report for {fmDetail ? fmDetail.name : null}
                    </span>
                    <span>
                      <Ionicon
                        icon="ios-arrow-forward"
                        fontSize="34px"
                        color="#fdbb1f"
                      />
                    </span>
                  </>
                )} */}
                <span className="current-page">
                  Details for <span className="title-case">{memberName}</span>
                  <span className="title-case">
                    {this.state.sapid &&
                      (this.state.sapid !== "undefined" ||
                        this.state.sapid !== undefined) &&
                      " (" + this.state.sapid + ")"}
                  </span>
                </span>
              </Col>
              {this.state.yearOptions.length > 1 && (
                <Col md="2" xs="12" style={{ paddingRight: "0px" }}>
                  <FormGroup>
                    <select
                      name="month"
                      className="form-control cursor-pointer"
                      value={this.state.year}
                      style={{
                        fontSize: "13px",
                        width: "110px",
                        color: "#6e777f",
                        marginLeft: "auto",
                      }}
                      onChange={(e) => {
                        this.onChangeYear(e, memberId);
                      }}
                    >
                      {this.state.yearOptions.map((item) => (
                        <option value={item.value} selected>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
              )}
            </Row>
          )}
        {!memberId &&
          (this.state.HOD === "false" ||
            this.state.HOD === false ||
            !this.state.HOD) && (
            <Row
              className={
                memberRole === Roles.FLEET_ROLE ? "" : "justify-content-between"
              }
              style={{
                // marginBottom:
                //   this.state.yearOptions.length > 3 ? "-17px" : "-6px",
                marginTop: "-10px",
              }}
            >
              <Col
                className="Points-Report"
                md={
                  memberRole === Roles.HEAD_OFFICE_BAADSHAH_ROLE &&
                    this.state.yearOptions.length > 1
                    ? "4"
                    : (memberRole === Roles.HEAD_OFFICE_BAADSHAH_ROLE &&
                      this.state.yearOptions.length <= 1) ||
                      (memberRole === Roles.ZONAL_FLEET_MANAGER_ROLE &&
                        this.state.yearOptions.length > 1) ||
                      memberRole === Roles.FLEET_MANAGER_ROLE
                      ? "6"
                      : memberRole === Roles.FLEET_ROLE
                        ? "4"
                        : "8"
                }
                xs="12"
              >
                {(StorageService.getUserDetail().type ===
                  Roles.HEAD_OFFICE_BAADSHAH_ROLE &&
                  "Point") ||
                  StorageService.getUserDetail().type ===
                  Roles.ZONAL_FLEET_MANAGER_ROLE
                  ? "Point"
                  : ""}{" "}
                Dashboard
                {StorageService.getUserDetail().type ===
                  Roles.HEAD_OFFICE_BAADSHAH_ROLE && (
                    <div className="zoneFont">
                      Showing results of a{" "}
                      {this.state.zoneName === "All India"
                        ? this.state.zoneName
                        : this.state.zoneName + " Zone"}
                      .
                    </div>
                  )}
              </Col>

              {StorageService.getUserDetail().type ===
                Roles.HEAD_OFFICE_BAADSHAH_ROLE &&
                this.state.yearOptions.length > 1 && (
                  <Col md="2" xs="12" style={{ paddingRight: "0px" }}>
                    <FormGroup style={{ marginRight: "-50px" }}>
                      <select
                        name="month"
                        className="form-control cursor-pointer"
                        value={this.state.year}
                        style={{
                          fontSize: "13px",
                          width: "110px",
                          color: "#6e777f",
                          marginLeft: "auto",
                        }}
                        onChange={(e) => {
                          this.onChangeYear(e, memberId);
                        }}
                      >
                        {this.state.yearOptions.map((item) => (
                          <option value={item.value} selected>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </FormGroup>
                  </Col>
                )}

              {StorageService.getUserDetail().type ===
                Roles.HEAD_OFFICE_BAADSHAH_ROLE && (
                  <Col md="2" xs="12" style={{ paddingRight: "0px" }}>
                    <FormGroup style={{ paddingLeft: "50px" }}>
                      <select
                        name="month"
                        className="form-control cursor-pointer"
                        value={this.state.zone}
                        style={{
                          fontSize: "13px",
                          width: "140px",
                          color: "#6e777f",
                        }}
                        onChange={(e) => {
                          this.onChangeZone(e);
                        }}
                      >
                        <option value="all" selected>
                          All India
                        </option>
                        <option value="nz" selected>
                          North
                        </option>
                        <option value="sz1">South 1</option>
                        <option value="sz2">South 2</option>
                        <option value="ez">East</option>
                        <option value="wz">West</option>
                      </select>
                    </FormGroup>
                  </Col>
                )}

              {memberRole !== Roles.FLEET_ROLE &&
                this.state.yearOptions.length > 1 &&
                StorageService.getUserDetail().type !==
                Roles.HEAD_OFFICE_BAADSHAH_ROLE &&
                StorageService.getUserDetail().type !==
                Roles.FLEET_MANAGER_ROLE && (
                  <Col md="2" xs="12" style={{ paddingLeft: "50px" }}>
                    <FormGroup>
                      <select
                        name="month"
                        className="form-control cursor-pointer"
                        value={this.state.year}
                        style={{
                          fontSize: "13px",
                          width: "110px",
                          color: "#6e777f",
                          marginLeft: "auto",
                        }}
                        onChange={(e) => {
                          this.onChangeYear(e, memberId);
                        }}
                      >
                        {this.state.yearOptions.map((item) => (
                          <option key={item.value} value={item.value} selected>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </FormGroup>

                    {/* <YTDFilter
                    updateZone={this.updateZone}
                    getOffTakeSalesEntry={filterValue =>
                      this.getOffTakeSalesEntry(filterValue)
                    }
                    ref={this.YTDFilter}
                  /> */}
                  </Col>
                )}

              {memberRole === Roles.FLEET_ROLE &&
                this.state.yearOptions.length > 1 && (
                  <Col
                    md="4"
                    xs="12"
                    className={memberRole === Roles.FLEET_ROLE ? "pr-0" : ""}
                  >
                    <FormGroup>
                      <select
                        name="month"
                        className="form-control cursor-pointer"
                        value={this.state.year}
                        style={{
                          fontSize: "13px",
                          width: "110px",
                          color: "#6e777f",
                          marginLeft: "auto",
                        }}
                        onChange={(e) => {
                          this.onChangeYear(e, memberId);
                        }}
                      >
                        {this.state.yearOptions.map((item) => (
                          <option key={item.value} value={item.value} selected>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </FormGroup>
                  </Col>
                )}

              {memberRole !== Roles.FLEET_ROLE && (
                <Col
                  md="4"
                  xs="12"
                  style={{ marginBottom: "10px", paddingRight: "0px" }}
                >
                  <AutoSuggestionDealer
                    {...this.props}
                    getSelectedFleetData={this.getSelectedFleetData}
                    zone={this.state.zone}
                  />
                </Col>
              )}
            </Row>
          )}

        {memberRole === Roles.FLEET_MANAGER_ROLE &&
          !memberId &&
          fmOfftakeEntriesCount.count > 0 && (
            <div
              className="page-title  report-gradient-title"
              style={{
                marginRight: "-15px",
                marginTop: "15px",
                marginBottom: "15px",
              }}
            >
              <Row
                onClick={this.onPendingInvoiceClick}
                style={{ cursor: "pointer", marginLeft: "auto" }}
              >
                <Col xs="8" className="report-gradient-small-text">
                  You have {fmOfftakeEntriesCount.count} invoices pending for
                  verification
                </Col>
                <Col
                  xs="4"
                  className="text-align-right report-gradient-big-text"
                >
                  Start Verification Now
                </Col>
              </Row>
              {/* Complete your business profile and earn 500 points */}
            </div>
          )}

        {memberRole === Roles.ZONAL_FLEET_MANAGER_ROLE &&
          !memberId &&
          fmOfftakeEntriesCount.count > 0 && (
            <div
              className="page-title  report-gradient-title"
              style={{ marginRight: "-15px", marginTop: "15px" }}
            >
              <Row
                onClick={this.onPendingInvoiceClick}
                style={{ cursor: "pointer" }}
              >
                <Col xs="8" className="report-gradient-small-text">
                  You have {fmOfftakeEntriesCount.count} invoices pending for
                  verification
                </Col>
                <Col
                  xs="4"
                  className="text-align-right report-gradient-big-text"
                >
                  Start Verification Now
                </Col>
              </Row>
              {/* Complete your business profile and earn 500 points */}
            </div>
          )}

        {memberRole === Roles.FLEET_ROLE && baadshahMessage && (
          <Row
            style={{ cursor: "pointer", marginLeft: "auto", marginTop: "10px" }}
          >
            <Col className="col-lg-8 col-xl-8 p-0 pb-2">
              {/* <Card> */}
              <CardBody
                className="report-gradient-title"
                onClick={() => this.redirectFromBannerAction()}
              >
                <span className=".gradient-sub-title">{baadshahMessage}</span>
              </CardBody>
            </Col>
            {/* </Card> */}
          </Row>
        )}

        {memberRole === Roles.FLEET_MANAGER_ROLE && !memberId && (
          <>
            <Card className="mt-2">
              <CardBody className="p-3">
                <Row>
                  <Col
                    xl="12"
                    md="12"
                    xs="12"
                    className="pb-3 d-flex-row justify-content-between"
                  >
                    <span className="Sales-Target-vs-Achi-title mt-auto mb-auto">
                      Sales Target vs Achievement
                    </span>
                    {StorageService.getUserDetail().type ===
                      Roles.FLEET_MANAGER_ROLE && (
                        <Col md="2" xs="12" style={{ paddingLeft: "25px" }}>
                          <YTDFilter
                            year2020={false}
                            updateZone={this.updateZone}
                            getOffTakeSalesEntry={(filterValue) =>
                              this.getOffTakeSalesEntry(filterValue)
                            }
                            ref={this.YTDFilter}
                          />
                        </Col>
                      )}
                  </Col>
                  <Col xl="4" className="margin-top-5 padding-right-0">
                    <Card className="height-100 sales-target-dashboard box-shadow-10px">
                      <CardBody className="p-0">
                        <Row className="w-100 p-0 m-0 ml-1">
                          <table className="border-0 ml-n1 table-responsive">
                            <thead className="thead-count dashboard-report-card-bg-image">
                              <th
                                style={{
                                  border: "none",
                                  borderRight: "solid 1px #FDF7E5",
                                }}
                                className="sales-target-dashboard-point-th"
                                colspan="2"
                              >
                                TBR
                              </th>
                              <th
                                style={{ border: "none", textAlign: "center" }}
                                className="sales-target-dashboard-point-td-lbl"
                              >
                                % Achievement
                              </th>
                            </thead>

                            <tbody>
                              <tr>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Direct sales
                                </td>
                                <td className="border-right-f4d073 sales-target-dashboard-point-td-lbl-value">
                                  {sales_achievement.tbr.direct_achievement +
                                    " "}
                                  /{" " + sales_achievement.tbr.direct_sales}
                                </td>
                                <td
                                  className="sales-target-dashboard-point-td-lbl-value"
                                  style={{ textAlign: "center" }}
                                >
                                  {sales_achievement.tbr.percent_direct_sales
                                    ? this.rounoffValues(
                                      sales_achievement.tbr
                                        .percent_direct_sales
                                    ) + "%"
                                    : 0}
                                </td>
                              </tr>
                              {/* <tr>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Indirect sales
                                </td>
                                <td className="border-right-f4d073 sales-target-dashboard-point-td-lbl-value">
                                  {sales_achievement.tbr.indirect_achievement + " "}/{" " + sales_achievement.tbr.indirect_sales}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value" style={{ textAlign: 'center' }}>
                                  {sales_achievement.tbr.percent_indirect_sales ? this.rounoffValues(sales_achievement.tbr.percent_indirect_sales) + '%' : 0}
                                </td>
                              </tr> */}
                              <tr style={{ borderTop: "1px solid #DBDDDF" }}>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Total Sales
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {sales_achievement.tbr.total_achievement +
                                    " "}
                                  /{" " + sales_achievement.tbr.total_sales}
                                </td>
                                <td
                                  className="sales-target-dashboard-point-td-lbl-value"
                                  style={{ textAlign: "center" }}
                                >
                                  {sales_achievement.tbr.percent_total_sales
                                    ? this.rounoffValues(
                                      sales_achievement.tbr
                                        .percent_total_sales
                                    ) + "%"
                                    : 0}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xl="4" className="margin-top-5 padding-right-0">
                    <Card className="height-100 sales-target-dashboard box-shadow-10px">
                      <CardBody className="p-0">
                        <Row className="w-100 p-0 m-0 ml-1">
                          <table className="border-0 ml-n1 table-responsive">
                            <thead className="thead-count dashboard-report-card-bg-image">
                              <th
                                style={{
                                  border: "none",
                                  borderRight: "solid 1px #FDF7E5",
                                }}
                                className="sales-target-dashboard-point-th"
                                colspan="2"
                              >
                                TBB
                              </th>
                              <th
                                style={{ border: "none", textAlign: "center" }}
                                className="sales-target-dashboard-point-td-lbl"
                              >
                                % Achievement
                              </th>
                            </thead>

                            <tbody>
                              <tr>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Direct sales
                                </td>
                                <td className="border-right-f4d073 sales-target-dashboard-point-td-lbl-value">
                                  {sales_achievement.tbb.direct_achievement +
                                    " "}
                                  /{" " + sales_achievement.tbb.direct_sales}
                                </td>
                                <td
                                  className="sales-target-dashboard-point-td-lbl-value"
                                  style={{ textAlign: "center" }}
                                >
                                  {sales_achievement.tbb.percent_direct_sales
                                    ? this.rounoffValues(
                                      sales_achievement.tbb
                                        .percent_direct_sales
                                    ) + "%"
                                    : 0}
                                </td>
                              </tr>
                              {/* <tr>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Indirect sales
                                </td>
                                <td className="border-right-f4d073 sales-target-dashboard-point-td-lbl-value">
                                  {sales_achievement.tbb.indirect_achievement + " "}/{" " + sales_achievement.tbb.indirect_sales}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value" style={{ textAlign: 'center' }}>
                                  {sales_achievement.tbb.percent_indirect_sales ? this.rounoffValues(sales_achievement.tbb.percent_indirect_sales) + '%' : 0}
                                </td>
                              </tr> */}
                              <tr style={{ borderTop: "1px solid #DBDDDF" }}>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Total Sales
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {sales_achievement.tbb.total_achievement +
                                    " "}
                                  /{" " + sales_achievement.tbb.total_sales}
                                </td>
                                <td
                                  className="sales-target-dashboard-point-td-lbl-value"
                                  style={{ textAlign: "center" }}
                                >
                                  {sales_achievement.tbb.percent_total_sales
                                    ? this.rounoffValues(
                                      sales_achievement.tbb
                                        .percent_total_sales
                                    ) + "%"
                                    : 0}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xl="4" className="margin-top-5">
                    <Card className="height-100 sales-target-dashboard box-shadow-10px">
                      <CardBody className="p-0">
                        <Row className="w-100 p-0 m-0 ml-1">
                          <table className="border-0 ml-n1 table-responsive">
                            <thead className="thead-count dashboard-report-card-bg-image">
                              <th
                                style={{
                                  border: "none",
                                  borderRight: "solid 1px #FDF7E5",
                                }}
                                className="sales-target-dashboard-point-th"
                                colspan="2"
                              >
                                Total
                              </th>
                              <th
                                style={{ border: "none", textAlign: "center" }}
                                className="sales-target-dashboard-point-td-lbl"
                              >
                                % Achievement
                              </th>
                            </thead>

                            <tbody>
                              <tr>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Direct sales
                                </td>
                                <td className="border-right-f4d073 sales-target-dashboard-point-td-lbl-value">
                                  {sales_achievement.total && (
                                    <>
                                      {sales_achievement.total
                                        .direct_achievement + " "}
                                      /
                                      {" " +
                                        sales_achievement.total.direct_sales}
                                    </>
                                  )}
                                </td>
                                <td
                                  className="sales-target-dashboard-point-td-lbl-value"
                                  style={{ textAlign: "center" }}
                                >
                                  {sales_achievement.total && (
                                    <>
                                      {sales_achievement.total
                                        .percent_direct_sales
                                        ? this.rounoffValues(
                                          sales_achievement.total
                                            .percent_direct_sales
                                        ) + "%"
                                        : 0}
                                    </>
                                  )}
                                </td>
                              </tr>
                              {/* <tr>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Indirect sales
                                </td>
                                <td className="border-right-f4d073 sales-target-dashboard-point-td-lbl-value">
                                  {
                                    sales_achievement.total && <>
                                      {sales_achievement.total.indirect_achievement + " "}/{" " + sales_achievement.total.indirect_sales}
                                    </>
                                  }
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value" style={{ textAlign: 'center' }}>
                                  {
                                    sales_achievement.total && <>
                                      {sales_achievement.total.percent_indirect_sales ? this.rounoffValues(sales_achievement.total.percent_indirect_sales) + '%' : 0}
                                    </>
                                  }
                                </td>
                              </tr> */}
                              <tr style={{ borderTop: "1px solid #DBDDDF" }}>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Total Sales
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {sales_achievement.total && (
                                    <>
                                      {sales_achievement.total
                                        .total_achievement + " "}
                                      /
                                      {" " +
                                        sales_achievement.total.total_sales}
                                    </>
                                  )}
                                </td>
                                <td
                                  className="sales-target-dashboard-point-td-lbl-value"
                                  style={{ textAlign: "center" }}
                                >
                                  {sales_achievement.total && (
                                    <>
                                      {sales_achievement.total
                                        .percent_total_sales
                                        ? this.rounoffValues(
                                          sales_achievement.total
                                            .percent_total_sales
                                        ) + "%"
                                        : 0}
                                    </>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

                {/* hide changes 8aug23 */}
                {/* <Row style={{ marginTop: "10px" }}>
                  <Col xl="12" md="12" xs="12" className="pb-3 mt-3">
                    <span className="Sales-Target-vs-Achi-title">Sales Analysis</span>  <span className="offtake-entry-text" style={{ float: 'inherit' }}>&nbsp;
                      (Offtake entry shows the average per month data.)
                    </span>
                  </Col>
                  <Col xl="4" className="margin-top-5 padding-right-0" style={{ maxWidth: '30%' }}>
                    <Card className="height-100 sales-target-dashboard box-shadow-10px">
                      <CardBody className="p-0">
                        <Row className="w-100 p-0 m-0 ml-1">
                          <table
                            className="border-0 ml-n1 table-responsive"
                          >
                            <thead className="thead-count dashboard-report-card-bg-image">
                              <tr>
                                <th style={{ border: 'none', borderRight: 'solid 1px #FDF7E5' }}
                                  className="sales-target-dashboard-point-th" colspan="3">
                                  <div className="d-flex-row justify-content-between">
                                    <span>
                                      Total Members (Fleet) of<br />
                                      JK Baadshah Programme
                                    </span>
                                    <span
                                      className={"hyperLink mr-3"}
                                      onClick={e =>
                                        this.downloadFleetStatusReport(
                                          e,
                                          this.state.total_count_fleetStatus,
                                          "header_total"
                                        )
                                      }
                                    >
                                      {this.state.total_count_fleetStatus}
                                    </span>
                                  </div>
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: 'none' }}></th>
                                <th className="sales-analysis-th"
                                  style={{ border: 'none' }}>
                                  Total
                                </th><th className="sales-analysis-th"
                                  style={{ border: 'none' }}>
                                  Active
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Direct
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  <span
                                    className={"hyperLink"}
                                    onClick={e =>
                                      this.downloadFleetStatusReport(e, "direct")
                                    }
                                  >
                                    {this.state.fleetStatusCountData[1] &&
                                      this.state.fleetStatusCountData[1]
                                        .direct_total_count}
                                  </span>
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.fleetStatusCountData[1] &&
                                    this.state.fleetStatusCountData[1]
                                      .direct_active_count}
                                </td>
                              </tr>
                              <tr>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Indirect
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  <span
                                    className={"hyperLink"}
                                    onClick={e =>
                                      this.downloadFleetStatusReport(e, "indirect")
                                    }
                                  >
                                    {" "}
                                    {this.state.fleetStatusCountData[1] &&
                                      this.state.fleetStatusCountData[1]
                                        .indirect_total_count}
                                  </span>
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.fleetStatusCountData[1] &&
                                    this.state.fleetStatusCountData[1]
                                      .indirect_active_count}
                                </td>
                              </tr>
                              <tr>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Mobility
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  <span

                                  >
                                    {" "}
                                    {this.state.fleetStatusCountData[1] &&
                                      this.state.fleetStatusCountData[1]
                                        .mobility_total_count}
                                  </span>
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.fleetStatusCountData[1] &&
                                    this.state.fleetStatusCountData[1]
                                      .mobility_active_count}
                                </td>
                              </tr>
                              <tr style={{ borderTop: '1px solid #DBDDDF' }}>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Total
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {" "}
                                  {this.state.fleetStatusCountData[1] &&
                                    this.state.fleetStatusCountData[1]
                                      .total_count}{" "}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {" "}
                                  {this.state.fleetStatusCountData[1] &&
                                    this.state.fleetStatusCountData[1]
                                      .total_active_count}{" "}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xl="5" className="margin-top-5 padding-right-0" style={{ maxWidth: '35%' }}>
                    <Card className="height-100 sales-target-dashboard box-shadow-10px">
                      <CardBody className="p-0">
                        <Row className="w-100 p-0 m-0 ml-1">
                          <table
                            className="border-0 ml-n1 table-responsive"
                          >
                            <thead className="thead-count dashboard-report-card-bg-image">
                              <tr>
                                <th style={{ border: 'none', borderRight: 'solid 1px #FDF7E5' }}
                                  className="sales-target-dashboard-point-th" colspan="4">
                                  <div className="d-flex-row justify-content-between">
                                    <span>
                                      Offtake as per sales<br />
                                      Entries
                                    </span>
                                    <div className="d-flex">


                                      <span
                                        className="Total-Members-Fleet hyperLink"
                                        style={{ fontSize: "18px" }}
                                        onClick={this.downloadSalesReport}
                                      >
                                        {this.rounoffValues(this.state.total_count_offtake)}
                                      </span>
                                      &nbsp;
                                      <span
                                        onClick={this.downloadSalesReport}
                                        className="Total-Members-Fleet hyperLink">
                                        Tyres
                                      </span>
                                    </div>

                                  </div>
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: 'none' }}></th>
                                <th className="sales-analysis-th"
                                  style={{ border: 'none' }}>
                                  TBR
                                </th><th className="sales-analysis-th"
                                  style={{ border: 'none' }}>
                                  TBB
                                </th>
                                <th className="sales-analysis-th"
                                  style={{ border: 'none' }}>
                                  Total
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Direct
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.tableData[0] &&
                                    this.rounoffValues(
                                      this.state.tableData[0].direct_tbr
                                    )}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.tableData[0] &&
                                    this.rounoffValues(
                                      this.state.tableData[0].direct_tbb
                                    )}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.tableData[0] &&
                                    this.rounoffValues(
                                      this.state.tableData[0].total_direct
                                    )}
                                </td>
                              </tr>
                              <tr>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Indirect
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">

                                  {this.state.tableData[0] &&
                                    this.rounoffValues(
                                      this.state.tableData[0].indirect_tbr
                                    )}

                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.tableData[0] &&
                                    this.rounoffValues(
                                      this.state.tableData[0].indirect_tbb
                                    )}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.tableData[0] &&
                                    this.rounoffValues(
                                      this.state.tableData[0].total_indirect
                                    )}
                                </td>
                              </tr>
                              <tr>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Mobility
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.tableData[0] &&
                                    this.rounoffValues(
                                      this.state.tableData[0].mobility_tbr
                                    )}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.tableData[0] &&
                                    this.rounoffValues(
                                      this.state.tableData[0].mobility_tbb
                                    )}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.tableData[0] &&
                                    this.rounoffValues(
                                      this.state.tableData[0].total_mobility
                                    )}
                                </td>
                              </tr>
                              <tr style={{ borderTop: '1px solid #DBDDDF' }}>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Total
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {" "}
                                  {this.state.tableData[0] &&
                                    this.rounoffValues(
                                      this.state.tableData[0].total_tbr
                                    )}{" "}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {" "}
                                  {" "}
                                  {this.state.tableData[0] &&
                                    this.rounoffValues(
                                      this.state.tableData[0].total_tbb
                                    )}{" "}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {" "}
                                  {this.state.tableData[0] &&
                                    this.rounoffValues(
                                      this.state.tableData[0].total
                                    )}{" "}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xl="5" className="margin-top-5" style={{ maxWidth: '35%' }}>
                    <Card className="height-100 sales-target-dashboard">
                      <CardBody className="p-0">
                        <Row className="w-100 p-0 m-0 ml-1">
                          <table
                            className="border-0 ml-n1 table-responsive"
                          >
                            <thead className="thead-count dashboard-report-card-bg-image">
                              <tr>
                                <th style={{ border: 'none', borderRight: 'solid 1px #FDF7E5' }}
                                  className="sales-target-dashboard-point-th" colspan="4">
                                  <div className="d-flex-row justify-content-between">
                                    <span>
                                      Verified Offtake (Based on <br />SAP
                                      data & Approved invoices)
                                    </span>
                                    <div className="d-flex">
                                      <span
                                        className="Total-Members-Fleet hyperLink"
                                        style={{ fontSize: "18px" }}
                                        onClick={this.downloadVerifiedSales}
                                      >
                                        {this.state.total_count_directIndirect}
                                      </span>&nbsp;
                                      <span onClick={this.downloadVerifiedSales}
                                        className="Total-Members-Fleet hyperLink">Tyres</span>
                                    </div>

                                  </div>
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: 'none' }}></th>
                                <th className="sales-analysis-th"
                                  style={{ border: 'none' }}>
                                  TBR
                                </th><th className="sales-analysis-th"
                                  style={{ border: 'none' }}>
                                  TBB
                                </th>
                                <th className="sales-analysis-th"
                                  style={{ border: 'none' }}>
                                  Total
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Direct
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.DirectIndirecttableData[1] &&
                                    this.state.DirectIndirecttableData[1].direct_tbr}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.DirectIndirecttableData[1] &&
                                    this.state.DirectIndirecttableData[1].direct_tbb}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.DirectIndirecttableData[1] &&
                                    this.state.DirectIndirecttableData[1]
                                      .direct_total}

                                </td>
                              </tr>
                              <tr>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Indirect
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">

                                  {this.state.DirectIndirecttableData[1] &&
                                    this.state.DirectIndirecttableData[1]
                                      .indirect_tbr}

                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.DirectIndirecttableData[1] &&
                                    this.state.DirectIndirecttableData[1]
                                      .indirect_tbb}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.DirectIndirecttableData[1] &&
                                    this.state.DirectIndirecttableData[1]
                                      .indirect_total}
                                </td>
                              </tr>
                              <tr>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Mobility
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.DirectIndirecttableData[1] &&
                                    this.state.DirectIndirecttableData[1]
                                      .mobility_tbr}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.DirectIndirecttableData[1] &&
                                    this.state.DirectIndirecttableData[1]
                                      .mobility_tbb}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.DirectIndirecttableData[1] &&
                                    this.state.DirectIndirecttableData[1]
                                      .mobility_total}
                                </td>
                              </tr>
                              <tr style={{ borderTop: '1px solid #DBDDDF' }}>
                                <td className="sales-target-dashboard-point-td-lbl">
                                  Total
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {" "}
                                  {this.state.DirectIndirecttableData[1] &&
                                    this.state.DirectIndirecttableData[1].total_tbr}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {" "}
                                  {this.state.DirectIndirecttableData[1] &&
                                    this.state.DirectIndirecttableData[1].total_tbb}
                                </td>
                                <td className="sales-target-dashboard-point-td-lbl-value">
                                  {this.state.DirectIndirecttableData[1] &&
                                    this.state.DirectIndirecttableData[1].total}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row> */}
              </CardBody>
            </Card>
          </>
        )}

        <div
          style={{
            marginTop:
              StorageService.getUserDetail().type !==
              Roles.HEAD_OFFICE_BAADSHAH_ROLE &&
              StorageService.getUserDetail().type !==
              Roles.ZONAL_FLEET_MANAGER_ROLE &&
              StorageService.getUserDetail().type !== Roles.FLEET_ROLE &&
              !memberId &&
              "0px",
          }}
        >
          {memberRole === Roles.FLEET_MANAGER_ROLE && !memberId && (
            <Row
              style={{
                marginBottom:
                  StorageService.getUserDetail().type ===
                  Roles.HEAD_OFFICE_BAADSHAH_ROLE ||
                  StorageService.getUserDetail().type ===
                  Roles.ZONAL_FLEET_MANAGER_ROLE ||
                  (StorageService.getUserDetail().type === Roles.FLEET_ROLE &&
                    "-22px"),
              }}
            >
              {" "}
              <Col md="4" xs="5">
                <div className="mb-3 mt-3 Points-Report-wrapp">
                  <div className="Points-Report-for-Tr ml-1">
                    Points Report for Truck / Bus
                  </div>
                </div>
              </Col>
              {this.state.yearOptions.length > 1 &&
                memberRole === Roles.FLEET_MANAGER_ROLE && (
                  <Col md="4" xs="5">
                    <Row className="justify-content-end">
                      <div
                        className="showingText"
                        style={{ paddingTop: "18px" }}
                      >
                        Financial Year &nbsp;
                      </div>
                      <FormGroup style={{ paddingTop: "10px" }}>
                        <select
                          name="month"
                          className="form-control cursor-pointer"
                          value={this.state.year}
                          style={{
                            fontSize: "13px",
                            width: "110px",
                            color: "#6e777f",
                            marginLeft: "auto",
                          }}
                          onChange={(e) => {
                            this.onChangeYear(e, memberId);
                          }}
                        >
                          {this.state.yearOptions.map((item) => (
                            <option value={item.value} selected>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </FormGroup>
                    </Row>
                  </Col>
                )}
            </Row>
          )}
          {/* {StorageService.getUserDetail().type !== Roles.HEAD_OFFICE_BAADSHAH_ROLE && (
            <div
              className="showingText"
              style={{ marginBottom: "-10px", marginTop: "-10px" }}
            >
              
              {this.state.year_name_value && this.state.year_name_value.name}.
            </div>
          )} */}

          <Row
            className={classnames("", {
              "cursor-pointer":
                (memberRole === Roles.FLEET_MANAGER_ROLE ||
                  memberRole === Roles.ZONAL_FLEET_MANAGER_ROLE) &&
                !memberId,
            })}
            onClick={
              (memberRole === Roles.FLEET_MANAGER_ROLE ||
                memberRole === Roles.ZONAL_FLEET_MANAGER_ROLE) &&
                !memberId
                ? this.openReportPage
                : null
            }
            style={{ marginBottom: "20px" }}
          >
            {/* <Col xl="4" className="margin-top-5 padding-right-0">
              <Card className="height-100 fleet-card-detail-count">
                <CardBody className="report-dashboard-card-center" style={{ padding: '15px', paddingRight: '0' }}>
                  <Row className="width-100" style={{height: '100%'}}>
                    <Col xl="12" md="12" xs="12" className="pb-2">
                      <Row>
                        <Col xl="8" md="12" xs="12" className="d-flex-column pr-0">
                          <span className="fleet-detail-carde-title">Year Till Date</span>
                        </Col>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0">
                          <span className="fleet-detail-carde-title" style={{ fontSize: '12px', float: 'right', marginTop: '5px' }}>{displayLabels && displayLabels.year}</span>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs="12">
                      <Row>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0">
                          <span className="Truck-lbl">Total Offtake</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '18px' }}>
                            {formatNumber(totalCard.total_offtake)} 
                          </span>
                        </Col>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0" style={{ borderRight: '1.2px solid rgb(110, 119, 127)' }}>
                          <span className="Truck-lbl">Eligible Offtake</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '18px' }}>
                            {formatNumber(totalCard.offtake)} 
                          </span>
                        </Col>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0">
                          <span className="Truck-lbl">Total Points</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '18px' }}>
                            {formatNumber(totalCard.points)} 
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col> */}

            <Col xl="4" className="margin-top-5 padding-right-0">
              <div className="height-100 dasboardCountCard yellowBgcard">
                <div
                  className="report-dashboard-card-center"
                  style={{ padding: "15px", paddingRight: "0" }}
                >
                  <Row className="width-100" style={{ height: "100%" }}>
                    <Col xl="12" md="12" xs="12" className="pb-2">
                      <Row style={{ marginBottom: "3px" }}>
                        <Col
                          xl="8"
                          md="12"
                          xs="12"
                          className="d-flex-column pr-0"
                        >
                          <span className="fleet-detail-carde-title">
                            Year Till Date*
                          </span>
                        </Col>
                        <Col
                          xl="4"
                          md="12"
                          xs="12"
                          className="d-flex-column pr-0 text-right"
                        >
                          <span
                            className="date-title"
                            style={{
                              fontSize: "12px",
                              float: "right",
                              marginTop: "5px",
                            }}
                          >
                            {displayLabels && displayLabels.year}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs="12">
                      <Row>
                        <Col
                          xl="4"
                          md="12"
                          xs="12"
                          className="d-flex-column pr-0"
                          style={{
                            borderRight: "1.2px solid rgb(110, 119, 127)",
                          }}
                        >
                          <span className="Truck-lbl">Total Points</span>
                          <span
                            className="fleet-detail-card-sub-title-count"
                            style={{ fontSize: "18px" }}
                          >
                            {formatNumber(totalCard.points)}
                          </span>
                        </Col>
                        <Col
                          xl="4"
                          md="12"
                          xs="12"
                          className="d-flex-column pr-0"
                          style={{ paddingLeft: "30px" }}
                        >
                          <span className="Truck-lbl">Total Offtake</span>
                          <span
                            className="fleet-detail-card-sub-title-count"
                            style={{ fontSize: "18px" }}
                          >
                            {formatNumber(totalCard.total_offtake)}
                          </span>
                        </Col>
                        {/* <Col xl="4" md="12" xs="12" className="d-flex-column pr-0" style={{ borderRight: '1.2px solid rgb(110, 119, 127)' }}>
                          <span className="Truck-lbl">Eligible Offtake</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '18px' }}>
                            {formatNumber(totalCard.offtake)}
                          </span>
                        </Col> */}
                      </Row>
                    </Col>
                    <Col xs="12" className="pr-0">
                      <p className="cardNote mb-0">
                        *Yearly points and offtake will be updated only after
                        the end of Quarter. Current quarter points are the
                        provisional points and not a part of Yearly points.
                      </p>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>

            {/*<Col xl="4" className="margin-top-5 padding-right-0">
              <Card className="height-100">
                <CardBody className="report-dashboard-card-center" style={{ padding: '15px', paddingRight: '0' }}>
                  <Row className="width-100" style={{height: '100%'}}>
                    <Col xl="12" md="12" xs="12" className="pb-2">
                      <Row>
                        <Col xl="8" md="12" xs="12" className="d-flex-column pr-0">
                          <span className="fleet-detail-carde-title">Previous Quarter</span>
                        </Col>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0">
                          {displayLabels && displayLabels.isCurrentYear === true ? <span className="fleet-detail-carde-title" style={{ fontSize: '12px', float: 'right' }}>{displayLabels && displayLabels.year_till_previous_quarter}</span> : ''}
                        </Col>
                      </Row>
                    </Col>
                    <Col xs="12">
                      <Row>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0">
                          <span className="Truck-lbl">Total Offtake</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '18px' }}>
                            {displayLabels && displayLabels.isCurrentYear === true ? formatNumber(previousQuarters.total_offtake) : '-'} 
                          </span>
                        </Col>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0" style={{ borderRight: '1.2px solid rgb(110, 119, 127)' }}>
                          <span className="Truck-lbl">Eligible Offtake</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '18px' }}>
                            {displayLabels && displayLabels.isCurrentYear === true ? formatNumber(previousQuarters.offtake) : '-'}
                          </span>
                        </Col>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0">
                          <span className="Truck-lbl">Total Points</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '18px' }}>
                                {displayLabels && displayLabels.isCurrentYear === true ? formatNumber(previousQuarters.points) : '-'}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
          </Col>*/}
            {/* <Col xl="4" className="margin-top-5 padding-right-0">
              <div className="height-100 dasboardCountCard whiteBgColor">
                <div className="report-dashboard-card-center" style={{ padding: '15px', paddingRight: '0' }}>
                  <Row className="width-100" style={{ height: '100%' }}>
                    <Col xl="12" md="12" xs="12" className="pb-2">
                      <Row>
                        <Col xl="8" md="12" xs="12" className="d-flex-column pr-0">
                          <span className="fleet-detail-carde-title">Current Quarter</span>
                        </Col>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0">
                          {displayLabels && displayLabels.isCurrentYear === true ? <span className="fleet-detail-carde-title" style={{ fontSize: '12px', float: 'right' }}>{displayLabels && displayLabels.quarter}</span> : ''}
                        </Col>
                      </Row>
                    </Col>
                    <Col xs="12">
                      <Row>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0">
                          <span className="Truck-lbl">Total Offtake</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '18px' }}>
                            {displayLabels && displayLabels.isCurrentYear === true ? formatNumber(currentQuarter.total_offtake) : '-'}
                          </span>
                        </Col>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0" style={{ borderRight: '1.2px solid rgb(110, 119, 127)' }}>
                          <span className="Truck-lbl">Eligible Offtake</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '18px' }}>
                            {displayLabels && displayLabels.isCurrentYear === true ? formatNumber(currentQuarter.offtake) : '-'}
                          </span>
                        </Col>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0">
                          <span className="Truck-lbl">Total Points</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '18px' }}>
                            {displayLabels && displayLabels.isCurrentYear === true ? formatNumber(currentQuarter.points) : '-'}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col> */}

            <Col xl="4" className="margin-top-5 padding-right-0">
              <div className="height-100 dasboardCountCard whiteBgCard">
                <div
                  className="report-dashboard-card-center"
                  style={{ padding: "15px", paddingRight: "0" }}
                >
                  <Row className="width-100" style={{ height: "100%" }}>
                    <Col xl="12" md="12" xs="12" className="pb-2">
                      <Row style={{ marginBottom: "3px" }}>
                        <Col
                          xl="8"
                          md="12"
                          xs="12"
                          className="d-flex-column pr-0"
                        >
                          <span className="fleet-detail-carde-title">
                            Current Quarter**
                          </span>
                        </Col>
                        <Col
                          xl="4"
                          md="12"
                          xs="12"
                          className="d-flex-column pr-0 text-right"
                        >
                          <span
                            className="date-title"
                            style={{
                              fontSize: "12px",
                              float: "right",
                              marginTop: "5px",
                            }}
                          >
                            {displayLabels &&
                              displayLabels.isCurrentYear === true
                              ? displayLabels.quarter
                              : ""}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs="12">
                      <Row>
                        <Col
                          xl="5"
                          md="12"
                          xs="12"
                          className="d-flex-column pr-0"
                          style={{
                            borderRight: "1.2px solid rgb(110, 119, 127)",
                          }}
                        >
                          <span className="Truck-lbl">Provisional Points</span>
                          <span
                            className="fleet-detail-card-sub-title-count"
                            style={{ fontSize: "18px" }}
                          >
                            {displayLabels &&
                              displayLabels.isCurrentYear === true
                              ? formatNumber(currentQuarter.points)
                              : "-"}
                          </span>
                        </Col>
                        <Col
                          xl="4"
                          md="12"
                          xs="12"
                          className="d-flex-column pr-0"
                          style={{ paddingLeft: "30px" }}
                        >
                          <span className="Truck-lbl">Total Offtake</span>
                          <span
                            className="fleet-detail-card-sub-title-count"
                            style={{ fontSize: "18px" }}
                          >
                            {displayLabels &&
                              displayLabels.isCurrentYear === true
                              ? formatNumber(currentQuarter.total_offtake)
                              : "-"}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs="12" className="pr-0">
                      <p className="cardNote mb-0">
                        **Current quarter points are provisional points. They
                        will get added to the yearly points at the end of
                        current quarter based on the achievement of the minimum
                        offtake criteria of the club.
                      </p>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>

            {/* <Col xl="4" className="margin-top-5 padding-right-0">
              <Card className="height-100">
                <CardBody className="report-dashboard-card-center" style={{ padding: '15px', paddingRight: '0' }}>
                  <Row className="width-100" style={{ height: '100%' }}>
                    <Col xl="12" md="12" xs="12" className="pb-2">
                      <Row>
                        <Col xl="8" md="12" xs="12" className="d-flex-column pr-0">
                          <span className="fleet-detail-carde-title">Current Month</span>
                        </Col>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0">
                          {displayLabels && displayLabels.isCurrentYear === true ? <span className="fleet-detail-carde-title" style={{ fontSize: '12px', float: 'right' }}>{displayLabels && displayLabels.month}</span> : ''}
                        </Col>
                      </Row>
                    </Col>
                    <Col xs="12">
                      <Row>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0">
                          <span className="Truck-lbl">Total Offtake</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '18px' }}>
                            {displayLabels && displayLabels.isCurrentYear === true && currentMonth && currentMonth.total_offtake ? formatNumber(currentMonth.total_offtake) : '-'}
                          </span>
                        </Col>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0" style={{ borderRight: '1.2px solid rgb(110, 119, 127)' }}>
                          <span className="Truck-lbl">Eligible Offtake</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '18px' }}>
                            {displayLabels && displayLabels.isCurrentYear === true && currentMonth && currentMonth.offtake ? formatNumber(currentMonth.offtake) : '-'}
                          </span>
                        </Col>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0">
                          <span className="Truck-lbl">Total Points</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '18px' }}>
                            {displayLabels && displayLabels.isCurrentYear === true && currentMonth && currentMonth.points ? formatNumber(currentMonth.points) : '-'}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col> */}
          </Row>

          {/* <div className="points-card-wrapp">
          <div className={classnames({ 'mr-3': !this.isMobile }, 'points-card total-points-card')}>
            <div className="points-img-wrapp">
              <img src="images/Web_Total Points.svg" alt='Web_Total Points />
            </div>
            <div className="d-flex-row Total-Points-Wrapp">
              <div className="points-data-wrapp" style={{ paddingRight: this.isMobile ? '0px' : '15px', marginBottom: 'unset' }}>
                <span className="points-label total-point-lable">Total Offtake</span>
                <span className="points" style={{ color: '#495057' }}>
                  {formatNumber(totalCard.offtake)}
                </span>
              </div>
              <div className="points-data-wrapp">
                <span className="points-label total-point-lable">Total Points</span>
                <span className="points" style={{ color: '#495057' }}>
                  {formatNumber(totalCard.points)}
                </span>
              </div>
            </div>
          </div>

          <div className={classnames({ 'mr-3': !this.isMobile }, 'points-card')} style={{ flexWrap: 'nowrap' }}>
            <div className="points-img-wrapp">
              <img src="images/Web_Earned Points.svg" alt='Web_Earned Points />
            </div>
            <div className="d-flex-row Provisional-Earned-Point-Wrapp">
              <div className="points-data-wrapp" style={{ paddingRight: this.isMobile ? '0px' : '15px', marginBottom: 'unset' }}>
                <span className="points-label total-point-lable" style={{ width: '100%' }}>Total Offtake ({previousQMonths})</span>
                <span className="points">
                  {formatNumber(previousQuarters.offtake)}
                </span>
              </div>
              <div className="points-data-wrapp">
                <span className="points-label total-point-lable" style={{ width: '100%' }}>Points ({previousQMonths})</span>
                <span className="points">
                  {formatNumber(previousQuarters.points)}
                </span>
              </div>

            </div>
          </div>

          <div className="points-card" style={{ flexWrap: 'nowrap' }}>
            <div className="points-img-wrapp">
              <img src="images/Web_Earned points Q2.svg" alt='Web_Earned points Q2 />
            </div>
            <div className="d-flex-column">
              <div className="d-flex-row Provisional-Earned-Point-Wrapp">
                <div className="points-data-wrapp" style={{ paddingRight: this.isMobile ? '0px' : '15px', marginBottom: 'unset', justifyContent: 'space-between' }}>
                  <span className="points-label total-point-lable" style={{ width: '100%' }}>Total Offtake ({currentQMonths})</span>
                  <span className="points">
                    {formatNumber(currentQuarter.offtake)}
                  </span>
                </div>
                <div className="points-data-wrapp">
                  <span className="points-label total-point-lable" style={{ width: '100%' }}>Provisional Points({currentQMonths})</span>
                  <span className="points">
                    {formatNumber(currentQuarter.points)}
                  </span>
                </div>
              </div>
              <span className="These-Points-are-pr">*These Points are provisional. They will get added to your total earned points at the end of Q2 if you are eligible.</span>
            </div>
          </div>
        </div> */}
          {// userDetail && userDetail.fleet_type !== null &&
              ((memberRole === Roles.FLEET_ROLE || memberId) &&
              <>
                {/* <div>
              <Row
                className="justify-content-start"
                style={{
                  marginBottom: '20px'
                }}
              >
                <Col xl="4" style={{ paddingRight: '0px' }}>
                  <Card className="height-100">
                    <CardBody style={{ padding: '10px' }}>
                      <span className="fleet-club-name">Club Name</span> - <span className="fleet-club-type-title">{userDetail.fleet_type.charAt(0).toUpperCase() + userDetail.fleet_type.slice(1)} Club</span>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div> */}
                <Row
                  style={{
                    marginBottom: "20px",
                  }}
                >
                  <Col xl="8" lg="8" className="clubBlockWrapper">
                    <div className="d-flex align-items-center clubBlock">
                      <div className="clubName">
                        <span className="clubNameMain">Club Name</span>
                        {" - "}
                        <span className="clubTitle">
                          {formatClubDisplayName(clubName)}
                        </span>
                      </div>
                      {isValidClubName(clubName) &&
                        clubPoint &&
                        clubPoint !== 0 && (
                        <div className="clubdescrBlock">
                          <div className="clubDescr1">
                            Point Eligibility Criteria: {clubPoint} Tyres per
                            Quarter
                          </div>
                          <div className="clubDescr1 clubDescr2">
                            This is a minimum offtake criteria for the{" "}
                            {formatClubLabel(clubName)} Club member
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </>
            )}
          {(memberRole === Roles.FLEET_ROLE || memberId !== null) &&
            (offtakeVerificationCount.pending > 0 ||
              offtakeVerificationCount.rejected > 0 ||
              offtakeVerificationCount.approved > 0) &&
            (StorageService.getUserDetail() &&
              StorageService.getUserDetail().permissions &&
              StorageService.getUserDetail().permissions.includes(
                Permissions.OFFTAKE_VERIFICATION_STATUS
              )) && (
              <div
                className="Offtake-Entries-Verification-Status-wrapp"
                onClick={this.goToOfftakeVerificationStatus}
                style={{ cursor: "pointer", marginBottom: "10px" }}
              >
                <img src="images/offtake-status.svg" alt="offtake-status" />
                <span className="Offtake-Entries-Verification-Status">
                  Offtake Entries Verification Status
                </span>
                <div className="offtake-Verification-Status-wrapp">
                  <div className="offtake-Verification-Status">
                    <span className="offtake-Verification-Status-pending">
                      {this.state.offtakeVerificationCount.pending
                        ? this.state.offtakeVerificationCount.pending
                        : 0}
                    </span>
                    <span className="offtake-Verification-Status-name">
                      Pending
                    </span>
                  </div>
                  <div className="offtake-Verification-Status">
                    <span
                      className="offtake-Verification-Status-pending"
                      style={{ color: "#e66c6c" }}
                    >
                      {this.state.offtakeVerificationCount.rejected}
                    </span>
                    <span className="offtake-Verification-Status-name">
                      Rejected
                    </span>
                  </div>
                  <div className="offtake-Verification-Status">
                    <span
                      className="offtake-Verification-Status-pending"
                      style={{ color: "#51b856" }}
                    >
                      {this.state.offtakeVerificationCount.approved}
                    </span>
                    <span className="offtake-Verification-Status-name">
                      Approved
                    </span>
                  </div>
                </div>
              </div>
            )}

          {(StorageService.getUserDetail().type !== Roles.FLEET_MANAGER_ROLE ||
            StorageService.getUserDetail().type === Roles.FLEET_MANAGER_ROLE) &&
            memberId && (
              <Col>
                <div className="mb-3 mt-3 Points-Report-wrapp">
                  <div className="Points-Report-for-Tr">
                    Points Report for Truck / Bus
                  </div>
                </div>
              </Col>
            )}
          <TruckBusPointsReports
            id="TruckBusPointsReports"
            truckBusPoints={this.primaryPointsReports}
            offTakeSummary={this.offTakeSummary}
            memberRole={this.state.memberRole}
            memberId={this.state.memberId}
            memberType={this.state.memberType}
            year={this.state.year}
            labels={labels.truck}
            totals={totals}
            loading={this.state.isLoader}
            userDetail={StorageService.getUserDetail()}
          />
        </div>
      </Fragment>
    );
  }
}

export default withRouter(DashboardReport);
